<script>
	// section label (category) — not a layout (not exported from index.js)
	import { kicker as getKicker } from "../../includes/content.js";
	export let content;
	export let link = true;
	$: k = getKicker(content);
</script>

{#if k}
	{#if link && k.href}
		<a class="af-kicker af-item__kicker" href={k.href}>{k.name}</a>
	{:else}
		<span class="af-kicker af-item__kicker">{k.name}</span>
	{/if}
{/if}

<style>
	.af-item__kicker {
		position: relative;
		z-index: 1;
	}
</style>
